var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as _ from 'lodash';
import moment from 'moment';
import { Messages } from 'primereact/messages';
import * as React from 'react';
import { withRouter } from 'react-router-dom';
import * as SlideFactory from '../../../classes/definitions/slide/slide';
import ApiRequests from '../../../classes/http/ApiRequests';
import HttpRequests from '../../../classes/http/HttpRequests';
import NotosService from '../../../classes/notos.service';
import AppRoutes from '../../../config/appRoutes';
import Config from '../../../config/config';
import slideSchema from '../../../schemas/slideSchema';
import Input from '../../UI/Input/Input';
// this component is used for both slides on the home page and brand slides
var SlideForm = /** @class */ (function (_super) {
    __extends(SlideForm, _super);
    function SlideForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.editId = '';
        _this.brandId = '';
        _this.brandSlideId = '';
        _this.categoryId = '';
        _this.categorySlideId = '';
        _this.messages = null;
        _this.imageChanged = false; // this will determine if the image has been changed
        _this.mobileImageChanged = false; // this will determine if the image has been changed
        // if no changes, no image prop will be sent to the backend
        _this.staticPageId = '';
        _this.staticPageSlideId = '';
        _this.state = {
            formConfig: _.cloneDeep(slideSchema),
            formIsValid: false,
            discardPopupVisble: false,
            isHomeSlide: false,
            isStaticPageSlide: false,
            brandName: null,
        };
        _this.getActionSlide = function () {
            if (_this.categoryId !== '-1') {
                return {
                    id: _this.categoryId,
                    slideId: _this.categorySlideId !== '-1' ? _this.categorySlideId : undefined,
                };
            }
            if (_this.staticPageId !== '-1') {
                return {
                    id: _this.brandId,
                    secondaryId: _this.staticPageId,
                    slideId: _this.staticPageSlideId,
                };
            }
            if (_this.brandId !== '-1') {
                return {
                    id: _this.brandId,
                    slideId: _this.brandSlideId !== '-1' ? _this.brandSlideId : undefined,
                };
            }
            return {
                id: _this.editId,
                slideId: undefined,
            };
        };
        _this.getSlide = function () {
            var actionMethod = _this.api.getSlide;
            if (_this.brandSlideId !== '-1' && _this.brandId !== '-1') {
                actionMethod = _this.api.getBrandSlide;
            }
            if (_this.categoryId !== '-1' && _this.categorySlideId !== '-1') {
                actionMethod = _this.api.getCategorySlide;
            }
            if (_this.staticPageId !== '-1' && _this.staticPageSlideId !== '-1') {
                actionMethod = _this.api.getStaticPageSlide;
            }
            var _a = _this.getActionSlide(), firstParam = _a.id, secondParam = _a.slideId, secondaryId = _a.secondaryId;
            var params = secondaryId ? [firstParam, secondaryId, secondParam] : [firstParam, secondParam];
            actionMethod.apply(void 0, params).then(function (response) {
                _this.setDataToForm(_.get(response, 'data.data', {}));
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при зареждане слайд';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        _this.setDataToForm = function (data) {
            var slide = SlideFactory.createSlide(_.get(data, 'attributes', {}));
            var imageUrl = slide.ImageUrl ? Config.cdnDomain + slide.ImageUrl : null;
            var mobileImageUrl = slide.MobileImageUrl ? Config.cdnDomain + slide.MobileImageUrl : null;
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            _.set(updatedFormConfig, 'link.value', slide.Link);
            _.set(updatedFormConfig, 'link.touched', true);
            _.set(updatedFormConfig, 'link.valid', true);
            _.set(updatedFormConfig, 'position.value', slide.Position ? slide.Position : null);
            _.set(updatedFormConfig, 'position.touched', true);
            _.set(updatedFormConfig, 'position.valid', true);
            _.set(updatedFormConfig, 'image.value', imageUrl);
            _.set(updatedFormConfig, 'image.touched', true);
            _.set(updatedFormConfig, 'image.valid', true);
            _.set(updatedFormConfig, 'mobile_image.value', mobileImageUrl);
            _.set(updatedFormConfig, 'mobile_image.touched', true);
            _.set(updatedFormConfig, 'mobile_image.valid', true);
            _.set(updatedFormConfig, 'countdown.value', slide.CountDown);
            _.set(updatedFormConfig, 'countdown.touched', true);
            _.set(updatedFormConfig, 'countdown.valid', true);
            _.set(updatedFormConfig, 'seo_name.value', slide.SeoName);
            _.set(updatedFormConfig, 'seo_name.touched', true);
            _.set(updatedFormConfig, 'seo_name.valid', true);
            if (_this.state.isHomeSlide) {
                _.set(updatedFormConfig, 'from_date.value', moment(slide === null || slide === void 0 ? void 0 : slide.FromDate, 'YYYY-MM-DD').toDate());
                _.set(updatedFormConfig, 'from_date.touched', true);
                _.set(updatedFormConfig, 'from_date.valid', true);
                _.set(updatedFormConfig, 'from_date_hour.value', slide === null || slide === void 0 ? void 0 : slide.FromDateHour);
                _.set(updatedFormConfig, 'from_date_hour.touched', true);
                _.set(updatedFormConfig, 'from_date_hour.valid', true);
                _.set(updatedFormConfig, 'to_date.value', moment(slide === null || slide === void 0 ? void 0 : slide.ToDate, 'YYYY-MM-DD').toDate());
                _.set(updatedFormConfig, 'to_date.touched', true);
                _.set(updatedFormConfig, 'to_date.valid', true);
                _.set(updatedFormConfig, 'to_date_hour.value', slide === null || slide === void 0 ? void 0 : slide.ToDateHour);
                _.set(updatedFormConfig, 'to_date_hour.touched', true);
                _.set(updatedFormConfig, 'to_date_hour.valid', true);
                _.set(updatedFormConfig, 'video_idx.value', slide.VideoIdx);
                _.set(updatedFormConfig, 'video_idx.touched', true);
                _.set(updatedFormConfig, 'video_idx.valid', true);
            }
            _this.setState({
                formConfig: updatedFormConfig,
                formIsValid: NotosService.checkFormValidity(updatedFormConfig),
            });
        };
        // handles input and blur events
        _this.eventHandlers = function (event, id, eventType) {
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            var updatedFormElement = __assign({}, updatedFormConfig[id]);
            if (updatedFormElement.elementType !== 'checkbox') {
                updatedFormElement.value = event.target.value;
            }
            else {
                updatedFormElement.value = event.checked;
            }
            updatedFormElement.valid = NotosService.checkFieldValidity(updatedFormElement.value, updatedFormElement.validation, eventType, updatedFormConfig);
            updatedFormElement.touched = true;
            updatedFormConfig[id] = updatedFormElement;
            if (id === 'image' && updatedFormElement.valid) {
                _this.imageChanged = true;
            }
            if (id === 'mobile_image' && updatedFormElement.valid) {
                _this.mobileImageChanged = true;
            }
            _this.setState({
                formConfig: updatedFormConfig,
                formIsValid: NotosService.checkFormValidity(updatedFormConfig),
            });
        };
        _this.getSubmitFormData = function (formData, slug) {
            if (slug === void 0) { slug = 'slide'; }
            var submittedSlide = new FormData();
            var image = _.get(formData, 'image.value', null);
            var mobile_image = _.get(formData, 'mobile_image.value', null);
            submittedSlide.append(slug + '[link]', _.get(formData, 'link.value', ''));
            submittedSlide.append(slug + '[position]', _.get(formData, 'position.value', ''));
            submittedSlide.append(slug + '[countdown]', _.get(formData, 'countdown.value', false));
            submittedSlide.append(slug + '[seo_name]', _.get(formData, 'seo_name.value', false));
            submittedSlide.append(slug + '[subscribe]', _.get(formData, 'subscribe.value', false));
            if (_this.state.isHomeSlide) {
                var toDate = moment(_.get(formData, 'to_date.value', ''));
                submittedSlide.append(slug + '[to_date]', toDate.format('YYYY-MM-DD'));
                submittedSlide.append(slug + '[to_date_hour]', _.get(formData, 'to_date_hour.value', ''));
                var fromDate = moment(_.get(formData, 'from_date.value', ''));
                var fromDateHour = _.get(formData, 'from_date_hour.value', '');
                submittedSlide.append(slug + '[from_date]', fromDate.format('YYYY-MM-DD'));
                submittedSlide.append(slug + '[from_date_hour]', fromDateHour);
                submittedSlide.append(slug + '[video_idx]', _.get(formData, 'video_idx.value', false));
            }
            if (_this.imageChanged && !image) {
                submittedSlide.append(slug + '[remove_image]', '1');
            }
            else if (_this.imageChanged && image) {
                submittedSlide.append(slug + '[image]', image);
            }
            if (_this.mobileImageChanged && !mobile_image) {
                submittedSlide.append(slug + '[remove_mobile_image]', '1');
            }
            else if (_this.mobileImageChanged && mobile_image) {
                submittedSlide.append(slug + '[mobile_image]', mobile_image);
            }
            return submittedSlide;
        };
        _this.getSubmitFormActionMethod = function (data) {
            if (_this.staticPageId !== '-1') {
                if (_this.staticPageSlideId === '-1') {
                    return _this.api.createStaticPageSlide(_this.brandId, _this.staticPageId, data);
                }
                return _this.api.updateStaticPageSlide(_this.brandId, _this.staticPageId, _this.staticPageSlideId, data);
            }
            if (_this.brandId !== '-1') {
                if (_this.brandSlideId === '-1') {
                    // create slide\
                    return _this.api.createBrandSlide(data, _this.brandId);
                }
                // update slide
                return _this.api.updateBrandSlide(data, _this.brandId, _this.brandSlideId);
            }
            if (_this.categoryId !== '-1') {
                if (_this.categorySlideId === '-1') {
                    // create slide
                    return _this.api.createCategorySlide(data, _this.categoryId);
                }
                return _this.api.updateCategorySlide(data, _this.categoryId, _this.categorySlideId);
            }
            if (_this.editId !== '-1') {
                return _this.api.updateSlide(data, _this.editId);
            }
            return _this.api.createSlide(data);
        };
        _this.submitForm = function (event) {
            event.preventDefault();
            var formData = _this.state.formConfig;
            var formSlug = _this.getSubmitFormSlug();
            var submittedSlide = _this.getSubmitFormData(formData, formSlug);
            var actionMethod = _this.getSubmitFormActionMethod(submittedSlide);
            actionMethod
                .then(function () {
                if (_this.staticPageId !== '-1') {
                    _this.toStaticSlidesPage();
                }
                else if (_this.brandId !== '-1') {
                    _this.toBrandSlidesPage();
                }
                else if (_this.categoryId !== '-1') {
                    _this.toCategorySlidesPage();
                }
                else {
                    _this.toSlidesPage();
                }
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при създаване на слайд';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        _this.toSlidesPage = function () {
            _this.props.history.push(AppRoutes.slides.path);
        };
        _this.toBrandSlidesPage = function () {
            _this.props.history.push(AppRoutes.brand.path + '/' + _this.brandId + AppRoutes.brandSlides.path);
        };
        _this.toStaticSlidesPage = function () {
            _this.props.history.push(AppRoutes.brand.path +
                '/' +
                _this.brandId +
                AppRoutes.staticPage.path +
                '/' +
                _this.staticPageId +
                AppRoutes.staticPageSlides.path);
        };
        _this.toCategorySlidesPage = function () {
            _this.props.history.push(AppRoutes.category.path + '/' + _this.categoryId + AppRoutes.categorySlides.path);
        };
        _this.removeSpecificHomeSlideInputs = function () {
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            delete updatedFormConfig.to_date;
            delete updatedFormConfig.to_date_hour;
            _this.setState({
                formConfig: updatedFormConfig,
                formIsValid: NotosService.checkFormValidity(updatedFormConfig),
            });
        };
        return _this;
    }
    SlideForm.prototype.componentDidMount = function () {
        this.editId = _.get(this.props, 'match.params.id', '-1');
        this.brandId = _.get(this.props, 'match.params.brandId', '-1');
        this.brandSlideId = _.get(this.props, 'match.params.brandSlideId', '-1');
        this.categoryId = _.get(this.props, 'match.params.categoryId', '-1');
        this.categorySlideId = _.get(this.props, 'match.params.categorySlideId', '-1');
        this.staticPageId = _.get(this.props, 'match.params.staticPageId', '-1');
        this.staticPageSlideId = _.get(this.props, 'match.params.staticPageSlideId', '-1');
        if (this.editId !== '-1') {
            this.getSlide();
        }
        if (this.brandSlideId !== '-1' || this.categorySlideId !== '-1' || this.staticPageSlideId !== '-1') {
            this.removeSpecificHomeSlideInputs();
            this.getSlide();
        }
        this.setState({
            isHomeSlide: this.categoryId === '-1' && this.brandId === '-1',
        });
        this.setState({
            isStaticPageSlide: this.brandId !== '-1' && this.staticPageId !== '-1',
        });
        if (this.brandId !== '-1') {
            this.getBrandName(this.brandId);
        }
    };
    SlideForm.prototype.getSubmitFormSlug = function () {
        if (this.staticPageId !== '-1') {
            return 'slide';
        }
        if (this.categoryId !== '-1') {
            return 'category_slide';
        }
        if (this.brandId !== '-1') {
            return 'brand_slide';
        }
        return 'slide';
    };
    SlideForm.prototype.getBrandName = function (brandId) {
        var _this = this;
        this.api
            .getBrand(brandId)
            .then(function (response) {
            var brandName = _.get(response, 'data.data.attributes.name', null);
            _this.setState({ brandName: brandName });
        })
            .catch(function (error) {
            var defaultMessage = 'Грешка при създаване на слайд';
            _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
        });
    };
    SlideForm.prototype.render = function () {
        var _this = this;
        var _a = this.state, formConfig = _a.formConfig, formIsValid = _a.formIsValid, isStaticPageSlide = _a.isStaticPageSlide, brandName = _a.brandName;
        var formElementsArray = [];
        // turning the formConfig from an object to an array
        for (var key in formConfig) {
            if (formConfig.hasOwnProperty(key)) {
                if (brandName !== 'CHANEL' || !isStaticPageSlide) {
                    if (formConfig.countdown.value === false) {
                        if (key !== 'subscribe') {
                            formElementsArray.push({
                                config: formConfig[key],
                                id: key,
                            });
                        }
                    }
                    else {
                        formElementsArray.push({
                            config: formConfig[key],
                            id: key,
                        });
                    }
                }
                else {
                    if (formConfig.countdown.value === false) {
                        if (key !== 'subscribe') {
                            formElementsArray.push({
                                config: formConfig[key],
                                id: key,
                            });
                        }
                    }
                    else {
                        formElementsArray.push({
                            config: formConfig[key],
                            id: key,
                        });
                    }
                }
            }
        }
        // turning the formConfig from an object to an array
        // Building form inputs
        var form = formElementsArray
            .filter(function (formElement) {
            // Conditionally add `video_idx` only if `isHomeSlide` is true
            if (formElement.id === 'video_idx') {
                return _this.state.isHomeSlide;
            }
            return true; // Keep all other elements
        })
            .map(function (formElement) {
            return (React.createElement(Input, { key: formElement.id, id: formElement.id, elementType: formElement.config.elementType, elementConfig: formElement.config.elementConfig, label: formElement.config.label, className: formElement.config.className, value: formElement.config.value, invalid: !formElement.config.valid, shouldValidate: formElement.config.validation, touched: formElement.config.touched, errorMsg: formElement.config.errorMsg, maxLength: formElement.config.maxLength, changed: function (event) { return _this.eventHandlers(event, formElement.id, 'onChange'); }, blur: function (event) { return _this.eventHandlers(event, formElement.id, 'onBlur'); } }));
        });
        var actionBtns = (React.createElement("div", { className: "modal-footer" },
            React.createElement("button", { className: "btn btn-sm btn-outline-primary", onClick: this.brandId !== '-1' ? this.toBrandSlidesPage : this.toSlidesPage, type: "button" },
                React.createElement("i", { className: "fa fa-ban" }),
                " \u041E\u0442\u043A\u0430\u0437"),
            React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.submitForm, disabled: !formIsValid, type: "button" },
                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                " OK")));
        return (React.createElement(React.Fragment, null,
            React.createElement(Messages, { ref: function (el) {
                    _this.messages = el;
                } }),
            form,
            actionBtns));
    };
    return SlideForm;
}(React.Component));
// @ts-ignore
export default withRouter(SlideForm);



//////////////////
// WEBPACK FOOTER
// ./src/components/Slides/SlideForm/SlideForm.tsx
// module id = 465
// module chunks = 0